export const DATAVIEW_APIS_FETCH_NOT_FOUND = 'DATAVIEW_APIS_FETCH_NOT_FOUND';
export const DATAVIEW_APIS_FETCH_FILES_NOT_FOUND = 'DATAVIEW_APIS_FETCH_FILES_NOT_FOUND';
export const DATAVIEW_APIS_FETCH_COLLABORATOR_REMOVED = 'DATAVIEW_APIS_FETCH_COLLABORATOR_REMOVED';
export const DATAVIEW_APIS_FETCH_BAD_SERVER_STATUS = 'DATAVIEW_APIS_FETCH_BAD_SERVER_STATUS';
export const DATAVIEW_APIS_FETCH_INVALID_GROUPS_COUNT = 'DATAVIEW_APIS_FETCH_INVALID_GROUPS_COUNT';
export const DATAVIEW_ACTIONS_GET_FALSY_REQUIRED_GROUP_TYPE = 'DATAVIEW_ACTIONS_GET_FALSY_REQUIRED_GROUP_TYPE';
export const DATAVIEW_APIS_FETCH_UNEXPECTED = 'DATAVIEW_APIS_FETCH_UNEXPECTED';

export const DATAVIEW_ACTIONS_GET_FALSY_PAYLOAD = 'DATAVIEW_ACTIONS_GET_FALSY_PAYLOAD';
export const DATAVIEW_ACTIONS_GET_UNEXPECTED = 'DATAVIEW_ACTIONS_GET_UNEXPECTED';

export const DATAVIEW_ACTIONS_INIT_FALSY_PAYLOAD = 'DATAVIEW_ACTIONS_INIT_FALSY_PAYLOAD';
export const DATAVIEW_ACTIONS_INIT_MISS_GROUPS = 'DATAVIEW_ACTIONS_INIT_MISS_GROUPS';
export const DATAVIEW_ACTIONS_INIT_MISS_COLLABORATORS = 'DATAVIEW_ACTIONS_INIT_MISS_COLLABORATORS';
export const DATAVIEW_ACTIONS_INIT_MISS_FILES = 'DATAVIEW_ACTIONS_INIT_MISS_FILES';
export const DATAVIEW_ACTIONS_INIT_MISS_FILERRS = 'DATAVIEW_ACTIONS_INIT_MISS_FILERRS';
export const DATAVIEW_ACTIONS_INIT_MISS_CURRENT_GROUP_ID = 'DATAVIEW_ACTIONS_INIT_MISS_CURRENT_GROUP_ID';
export const DATAVIEW_ACTIONS_INIT_MISS_CURRENT_COLLABORATOR_ID = 'DATAVIEW_ACTIONS_INIT_MISS_CURRENT_COLLABORATOR_ID';
export const DATAVIEW_ACTIONS_INIT_MISS_CURRENT_FILERR_ID = 'DATAVIEW_ACTIONS_INIT_MISS_CURRENT_FILERR_ID';
export const DATAVIEW_ACTIONS_INIT_MISS_CURRENT_FILE_ID = 'DATAVIEW_ACTIONS_INIT_MISS_CURRENT_FILE_ID';
export const DATAVIEW_ACTIONS_INIT_UNEXPECTED = 'DATAVIEW_ACTIONS_INIT_UNEXPECTED';
